import { render, staticRenderFns } from "./modal-bulk-delete-article-watches.vue?vue&type=template&id=23d16e66&"
import script from "./modal-bulk-delete-article-watches.vue?vue&type=script&lang=js&"
export * from "./modal-bulk-delete-article-watches.vue?vue&type=script&lang=js&"
import style0 from "./modal-bulk-delete-article-watches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports